import moment from "moment"
import { useState } from "react"
import { Model } from "../../models/model"
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"


export const FormNewTask = ({ tasksList, setTasksList, setOpenForm, idOpor, handleGetTasks, listaClasificacionTask }) => {

    const [form, setForm] = useState({
        id: null,
        nombre: '',
        fecha: moment(new Date()).format('YYYY-MM-DD'),
        hora: null,
        responsable: '--',
        id_oportunidad: idOpor,
        id_clasificacion: 6, // pendiente por defecto,
        nota_larga: null
    })

    const handleChange = (e) => {

        if (e.target.name === 'id_clasificacion') {
            const foundClas = listaClasificacionTask.find(it => it.id === e.target.value)

            setForm({
                ...form,
                [e.target.name]: e.target.value,
                nombre: foundClas ? foundClas.default_text : ''
            })

        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            })
        }


    }

    const handleSave = async (e) => {
        e.preventDefault()

        const newId = (tasksList?.length || 0) + 1

        const newTask = {
            id: newId,
            nombre: form?.nombre || '',
            fecha: form?.fecha || '',
            hora: form?.hora || '',
            responsable: '',
            done: false,
            edit: true
        }

        setTasksList([
            ...tasksList,
            newTask
        ])

        const result = await Model.save({
            url: 'crm/newTask',
            dataForm: form,
            resultData: true
        })

        console.log({ result })

        setForm({
            id: null,
            nombre: '',
            fecha: new Date(),
            hora: new Date()
        })

        setOpenForm(false)

        await handleGetTasks()

    }

    return (
        <form
            onSubmit={handleSave}
            className='bg-white p-2 rounded border-1 border-[#8f24aa]'
        >
            <div className="m-2">
                <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Tipo actividad</InputLabel>
                    <Select
                        label="Tipo actividad"
                        id="id_clasificacion"
                        name="id_clasificacion"
                        value={form.id_clasificacion || ''}
                        onChange={handleChange}
                        className='p-list-capitalize'
                    >
                        <MenuItem value='' key=''>Ninguno</MenuItem>
                        {listaClasificacionTask.map(item => (
                            <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                <i className={`${item.icon_name} text-[14px]`}></i>
                                <span className="ms-1 text-[14px]">{item.nombre}</span>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className='m-2'>
                <TextField
                    label="Nombre actividad"
                    name="nombre"
                    id="outlined-size-small"
                    value={form?.nombre || ''}
                    size="small"
                    fullWidth
                    placeholder='Ingrese actividad'
                    onChange={handleChange}
                    required
                />
            </div>
            <div className='m-2'>
                <label className='border border-gray-200 p-1 rounded'>
                    <input
                        type="date"
                        name="fecha"
                        value={form.fecha}
                        required
                        onChange={handleChange}
                    />
                </label>
                <label className='ms-2 border border-gray-200 p-1 rounded'>
                    <input
                        type="time"
                        name="hora"
                        placeholder="hh:mm"
                        value={form.hora}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className='m-2'>
                <TextField
                    fullWidth
                    className='text-area-resize'
                    id="outlined-multiline-static"
                    name="nota_larga"
                    label="Nota"
                    multiline
                    rows={5}
                    value={form.nota_larga || ''}
                    onChange={handleChange}
                />
            </div>
            <div className='text-end me-3'>
                <button
                    type="button"
                    className='me-4'
                    onClick={() => setOpenForm(false)}
                >Cancelar</button>
                <button
                    type="submit"
                    className='btn border-gray-200'
                >Guardar</button>
            </div>
        </form>
    )


}